/* eslint-disable operator-linebreak */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import HighChartGraph, { ApiHandler as HC, HighChartOptions } from 'wdna-highchart';

import { emptyData, getDateFormat } from 'wdna-components/lib/helpers/highchart';

import pressets from './pressets';

interface Props {
  title: string;
  data: any[];
}

type State = unknown;

export default class Chart extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  public shouldComponentUpdate = (nextProps: Props): boolean => {
    return this.props.data !== nextProps.data;
  };

  public getOptions = (): any => {
    const { title } = this.props;
    const { axisX } = getDateFormat('rop');

    const options: HighChartOptions = _.cloneDeep(pressets.line);
    const hc: HC = new HC(options);
    hc.setOption('title.text', `<b>${title}</b>`);
    hc.setOption('chart.height', '450px');
    hc.setXAxisFormat(axisX);

    return options;
  };

  public getTypeGraph = (data: any[]): void => {
    if (data !== undefined) {
      for (let i: number = 0; i < data.length; i++) {
        if (data[i].name.startsWith('Pluviometry')) {
          data[i].type = 'column';
        }
      }
    }
  }

  public render(): JSX.Element {
    const { data } = this.props;
    const options: any = this.getOptions();

    // Change graph type to column if variable is pluviometry
    this.getTypeGraph(data);

    const style: React.CSSProperties = { height: 'calc(35vh)', minHeight: '460px' };
    return (
      <div style={style}>
        <HighChartGraph data={data || emptyData} options={options} settings />
      </div>
    );
  }
}
